export var SchoolSupportStatus;
(function (SchoolSupportStatus) {
    SchoolSupportStatus["Active"] = "active";
    SchoolSupportStatus["Inactive"] = "inactive";
    SchoolSupportStatus["Paused"] = "paused";
})(SchoolSupportStatus || (SchoolSupportStatus = {}));
